import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';
import { CountryModalComponent } from './country-modal/country-modal.component';
import { CountryService } from 'src/app/services/country.service';

@Component({
  selector: 'app-country',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css']
})
export class CountryComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private countryService: CountryService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  countriesList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getCountries();
  }

  getCountries(){
    this.countryService.getCountrys().subscribe({
      next: (res: any) => {
        this.countriesList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      }});
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(CountryModalComponent, {
      data: { item, mode, title }
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getCountries();
        }
      }
    });
  }

}
